// extracted by mini-css-extract-plugin
module.exports = {"itemBox":"CustomItem_itemBox__13EoS","blockColor":"CustomItem_blockColor__vStD-"};